import React, { useContext, useEffect, useState } from "react";
import styles from "./index.module.css";
import { useParams } from "react-router-dom";
import { token_api } from "../../Utils/Network";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import {
  Box,
  Card,
  CardContent,
  Dialog,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { UserCredsContext } from "../../ContextApis/UserCredsContext/UserCredsContext";
import { findObject } from "../../Utils/Utils";
import EditIcon from "@mui/icons-material/Edit";
import EditFieldsForm from "../Students/EditFieldsForm";
import styled from "@emotion/styled";
import CustomStudentProfile from "../../Components/CustomStudentProfile/CustomStudentProfile";
import CustomConcern from "../../Components/CustomConcern/CustomConcern";
import CustomDreamCareer from "../../Components/CustomDreamCareer/CustomDreamCareer";
import CustomJudgementTwo from "../../Components/CustomJudgementTwo/CustomJudgementTwo";
import CustomRecommendationTwo from "../../Components/CustomRecommendationTwo/CustomRecommendationTwo";
import DynamicCategorySection from "./DynamicCategorySection";
import GenericCategoryComponent from "./GenericCategoryComponent";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const StudentProfile = () => {
  const { sid } = useParams();
  const [details, setDetails] = useState({});
  const [que, setQue] = useState([]);
  const [sessionAnswers, setSessionAnswers] = useState({});
  const [areaQue, setAreaQue] = useState([]);
  const [areaAns, setAreaAns] = useState({});
  const [dreamQue, setDreamQue] = useState([]);
  const [dreamAns, setDreamAns] = useState({});
  const [judgementQue, setjudgementQue] = useState([]);
  const [judgementAns, setjudgementAns] = useState({});
  const [recommQue, setRecommQue] = useState([]);
  const [recommAns, setRecommAns] = useState({});
  const [expandedAccordion, setExpandedAccordion] = useState(false);
  const [sectionType, setSectionType] = useState(editSection[0]);
  const { gradeList, instituteList } = useContext(UserCredsContext);
  const [open, setOpen] = useState(false);
  const [editObject, setEditObject] = useState({});
  const [objForForm, setObjForForm] = React.useState({});
  const [testDet, setTestDet] = useState([]);

  const [testResponce, setTestResponce] = useState("");
  const [areaResponce, setAreaResponce] = useState("");
  const [dreamResponce, setDreamResponce] = useState("");
  const [judgResponce, setJudgResponce] = useState("");
  const [recoResponce, setRecoResponce] = useState("");
  const [categories, setCategories] = useState([]);
  const [categoryQuestions, setCategoryQuestions] = useState({});
  const [categoryAnswers, setCategoryAnswers] = useState({});
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  // Map category title to custom component if needed
  const customComponentMap = {
    "Student Profile": CustomStudentProfile,
    "Area of concern": CustomConcern,
    "Dream Career Details": CustomDreamCareer,
    Judgement: CustomJudgementTwo,
    Recommendation: CustomRecommendationTwo,
    default: GenericCategoryComponent,
  };

  useEffect(() => {
    if (sid) {
      getStudentDetails(sid);
    }
  }, [sid]);

  const getStudentDetails = (id) => {
    // const response = await token_api.get(`/counseling/get_user_deta/${id}`);
    token_api
      .get(`/counseling/get_user_deta/${id}`)
      .then((response) => {
        setDetails(response?.data?.data);
        setObjForForm(response?.data?.data);
        setTestResponce(response?.data?.data?.extra_info?.student_profile);
        setAreaResponce(response?.data?.data?.extra_info?.area_of_concern);
        setDreamResponce(response?.data?.data?.extra_info?.dream_career);
        setJudgResponce(response?.data?.data?.extra_info?.judgment);
        setRecoResponce(response?.data?.data?.extra_info?.recommendation);
        const gradeId = response?.data?.data?.profile?.grade?.id;
        fetchCategoriesAndQuestions(gradeId);
        token_api
          .get(`/counseling/test_result/?user_id=${id}`)
          .then((response) => setTestDet(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchCategoriesAndQuestions = async (gradeId) => {
    const res = await token_api.get(`counseling/v1/counseling_categories`);
    setCategories(res.data.data);
    res.data.data.forEach(async (cat) => {
      const qRes = await token_api.get(
        `/counseling/v1/counseling_questions?category=${cat.id}&grade=${gradeId}`
      );
      setCategoryQuestions((prev) => ({ ...prev, [cat.id]: qRes.data.data }));
      setCategoryAnswers((prev) => ({ ...prev, [cat.id]: {} }));
    });
  };

  const handleCategoryAnswerChange = (
    categoryId,
    sessionId,
    questionId,
    choice,
    answer
  ) => {
    setCategoryAnswers((prev) => {
      const prevSession = prev[categoryId]?.[sessionId] || [];
      const updatedSession = prevSession.filter(
        (q) => q.question !== questionId
      );
      return {
        ...prev,
        [categoryId]: {
          ...prev[categoryId],
          [sessionId]: [
            ...updatedSession,
            { question: questionId, choice, answer },
          ],
        },
      };
    });
  };

  const saveCategoryAnswers = (categoryId, sessionId) => {
    // debugger;
    setLoading(true);
    const payload = {
      session_id: sessionId,
      data: categoryAnswers[categoryId]?.[sessionId] || [],
    };
    token_api
      .post(
        `/counseling/v1/counseling_questions/save_question_answers/`,
        payload
      )
      .then((res) => {
        // Optionally update response state here
        if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
          if (categoryId === 1) {
            setTestResponce(res?.data?.data?.response);
          } else if (categoryId === 2) {
            setAreaResponce(res?.data?.data?.response);
          } else if (categoryId === 3) {
            setDreamResponce(res?.data?.data?.response);
          } else if (categoryId === 4) {
            setJudgResponce(res?.data?.data?.response);
          } else if (categoryId === 5) {
            setRecoResponce(res?.data?.data?.response);
          } else if (categoryId === 6) {
          }
          setLoading(false);
        } else {
          setLoading(false);
          alert("Something went wrong");
        }

        console.log(res, "nfw4eifudyhw48yefdcjkl");

        // alert(`${res?.data?.data?.response}`)
      })
      .catch((err) => {
        setLoading(false);
        alert("Something went wrong");
      })
      .finally(() => {
        setLoading(false);
        // alert("Something went wrong");
      });
  };
  console.log(categoryAnswers, categoryQuestions, "3o9qwdsuhijklqwdj");
  const handleAnswerChange = (
    sessionId,
    questionId,
    choice = null,
    answer = null
  ) => {
    setSessionAnswers((prev) => {
      const prevSession = prev[sessionId] || [];
      const updatedSession = prevSession.filter(
        (q) => q.question !== questionId
      );

      return {
        ...prev,
        [sessionId]: [
          ...updatedSession,
          {
            question: questionId,
            choice,
            answer,
          },
        ],
      };
    });
  };

  const handleareaAnswerChange = (
    sessionId,
    questionId,
    choice = null,
    answer = null
  ) => {
    setAreaAns((prev) => {
      const prevSession = prev[sessionId] || [];
      const updatedSession = prevSession.filter(
        (q) => q.question !== questionId
      );

      return {
        ...prev,
        [sessionId]: [
          ...updatedSession,
          {
            question: questionId,
            choice,
            answer,
          },
        ],
      };
    });
  };
  const handleDreamAnswerChange = (
    sessionId,
    questionId,
    choice = null,
    answer = null
  ) => {
    setDreamAns((prev) => {
      const prevSession = prev[sessionId] || [];
      const updatedSession = prevSession.filter(
        (q) => q.question !== questionId
      );

      return {
        ...prev,
        [sessionId]: [
          ...updatedSession,
          {
            question: questionId,
            choice,
            answer,
          },
        ],
      };
    });
  };

  const handlejudgementAnswerChange = (
    sessionId,
    questionId,
    choice = null,
    answer = null
  ) => {
    setjudgementAns((prev) => {
      const prevSession = prev[sessionId] || [];
      const updatedSession = prevSession.filter(
        (q) => q.question !== questionId
      );

      return {
        ...prev,
        [sessionId]: [
          ...updatedSession,
          {
            question: questionId,
            choice,
            answer,
          },
        ],
      };
    });
  };

  const handleRecomAnswerChange = (
    sessionId,
    questionId,
    choice = null,
    answer = null
  ) => {
    setRecommAns((prev) => {
      const prevSession = prev[sessionId] || [];
      const updatedSession = prevSession.filter(
        (q) => q.question !== questionId
      );

      return {
        ...prev,
        [sessionId]: [
          ...updatedSession,
          {
            question: questionId,
            choice,
            answer,
          },
        ],
      };
    });
  };
  // console.log(sessionAnswers, "wemrpf9idujksdfajdks");
  const handleClickOpen = (string, objForEdit) => {
    setOpen(true);
    // setStateForEdit(id);
    const retObj = findObject(editSection, string, "type");
    console.log("ret", retObj);

    setSectionType(retObj);
    setEditObject(objForEdit);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // test pdf api

  const openTestPdf = (e, id, testtype) => {
    // console.log("idpdf", id);
    // console.log("typepdf",testtype);

    token_api
      .get(`/counseling/overall_result/?user_id=${id}&test_type=${testtype}`)
      .then((response) => {
        console.log(response.data.data.pdf);
        response.data.data.pdf
          ? window.open(response.data.data.pdf)
          : alert("User has not given the test");
      });
  };

  const buildPayloadForSession = (sessionId) => {
    const sessionPayload = {
      session_id: sessionId,
      data: sessionAnswers[sessionId] || [],
    };
    // return {
    //   session_id: sessionId,
    //   data: sessionAnswers[sessionId] || [],
    // };

    console.log(sessionPayload, "buildPayloadForSession");
    token_api
      .post(
        `counseling/v1/counseling_questions/save_question_answers/`,
        sessionPayload
      )
      .then((res) => {
        console.log(res?.data?.data, res?.status, "postResponces");

        setTestResponce(res?.data?.data?.response);
      })
      .catch((err) => console.log(err));
  };

  const areaOfConcern = (sessionId) => {
    const sessionPayload = {
      session_id: sessionId,
      data: areaAns[sessionId] || [],
    };
    // return {
    //   session_id: sessionId,
    //   data: sessionAnswers[sessionId] || [],
    // };

    console.log(sessionPayload, "buildPayloadForSession");
    token_api
      .post(
        `counseling/v1/counseling_questions/save_question_answers/`,
        sessionPayload
      )
      .then((res) => {
        console.log(res?.data?.data, res?.status, "postResponces");

        setAreaResponce(res?.data?.data?.response);
      })
      .catch((err) => console.log(err));
  };
  const dreamCareer = (sessionId) => {
    const sessionPayload = {
      session_id: sessionId,
      data: dreamAns[sessionId] || [],
    };
    // return {
    //   session_id: sessionId,
    //   data: sessionAnswers[sessionId] || [],
    // };

    console.log(sessionPayload, "buildPayloadForSession");
    token_api
      .post(
        `counseling/v1/counseling_questions/save_question_answers/`,
        sessionPayload
      )
      .then((res) => {
        console.log(res?.data?.data, res?.status, "postResponces");

        setDreamResponce(res?.data?.data?.response);
      })
      .catch((err) => console.log(err));
  };
  const judgement = (sessionId) => {
    const sessionPayload = {
      session_id: sessionId,
      data: judgementAns[sessionId] || [],
    };
    // return {
    //   session_id: sessionId,
    //   data: sessionAnswers[sessionId] || [],
    // };

    console.log(sessionPayload, "buildPayloadForSession");
    token_api
      .post(
        `counseling/v1/counseling_questions/save_question_answers/`,
        sessionPayload
      )
      .then((res) => {
        console.log(res?.data?.data, res?.status, "postResponces");

        setJudgResponce(res?.data?.data?.response);
      })
      .catch((err) => console.log(err));
  };
  const recommendation = (sessionId) => {
    const sessionPayload = {
      session_id: sessionId,
      data: recommAns[sessionId] || [],
    };
    // return {
    //   session_id: sessionId,
    //   data: sessionAnswers[sessionId] || [],
    // };

    console.log(sessionPayload, "buildPayloadForSession");
    token_api
      .post(
        `counseling/v1/counseling_questions/save_question_answers/`,
        sessionPayload
      )
      .then((res) => {
        console.log(res?.data?.data, res?.status, "postResponces");

        setRecoResponce(res?.data?.data?.response);
      })
      .catch((err) => console.log(err));
  };

  // downloade test

  const handleCareerCounsellingReport = (userId, reportType) => {
      console.log("CareerResporttyepe", reportType);
  
      if (reportType == false) {
        // call online
        token_api
          .get(
            `/counseling/career/report/career_counselling_report/?user_id=${userId}`
          )
          .then((response) => {
            console.log("pdfResponse", response);
            window.open(response.data.data.file);
          })
          .catch((err) => {
            alert("Error!Report cannot be generated");
          });
      } else if (reportType == true) {
        // call offline
        token_api
          .get(
            `counseling/career/report/career_counselling_offline_report/?user_id=${userId}`
          )
          .then((response) => {
            console.log("OfflineResport", response);
            if (response.data.data.file) {
              window.open(response.data.data.file);
            } else {
              alert("Error! Report does not exist");
            }
          })
          .catch((err) => {
            alert("Error! Report does not exist");
          });
      }
    };


  return (
    <div>
      <h2>
        {details?.first_name} {details?.last_name}
      </h2>

      <Box
        sx={{
          width: "95%",
          margin: "auto",
          color: "#696984",
          fontSize: "1em",
        }}
      >
        <Stack direction="row" spacing={5}>
          <Box>
            <Typography>Grade: {details.profile?.grade?.title}</Typography>
            <Typography>
              Gender:{" "}
              {
                gender[gender.findIndex((item) => item.id == details.gender)]
                  ?.name
              }
            </Typography>
          </Box>
          <Box>
            <Typography>
              Institute:{" "}
              {
                instituteList[
                  instituteList.findIndex(
                    (item) => item.id == details.profile?.institute
                  )
                ]?.name
              }
            </Typography>
            <Typography>DOB: {details.profile?.dob}</Typography>
          </Box>
        </Stack>
      </Box>

      <Box
        sx={{
          width: "100%",
          margin: "auto",
          color: "#696984",
        }}
      >
        <Typography
          sx={{
            marginTop: "15px",
            marginBottom: "15px",
            fontSize: "1.125em",
            color: "#696984",
            fontWeight: "bold",
          }}
        >
          Guardian Info:{" "}
          {details?.guardian?.length == 0 ? (
            <Typography>No Guardian Info available.</Typography>
          ) : null}
        </Typography>
        <Stack direction="column" spacing={3}>
          {details?.guardian?.map((gE, indiex) => {
            return (
              <Card
                sx={{
                  backgroundColor: "#FFFFFF",
                  color: "#696984",
                  border: "1px solid #7E7E7E",
                  paddingTop: "5px",
                  width: "auto",
                }}
              >
                <CardContent color="#696984" sx={{ paddingTop: "2px" }}>
                  <EditIcon
                    sx={{
                      marginLeft: "98%",
                      fontSize: "15px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleClickOpen("guardianDetails", gE)}
                  />
                  <Stack direction="row" spacing={4}>
                    <Box sx={{ width: "100%" }}>
                      <Stack direction="column" spacing={1}>
                        <Typography>
                          Name:{" "}
                          {gE ? gE?.first_name + " " + gE?.last_name : "-"}
                        </Typography>
                        <Typography>Email: {gE ? gE?.email : "-"}</Typography>
                        <Typography>
                          Education: {gE ? gE?.education : "-"}
                        </Typography>
                      </Stack>
                    </Box>
                    <Box sx={{ width: "100%" }}>
                      <Stack direction="column" spacing={1}>
                        <Typography>Mobile: {gE ? gE?.phone : "-"}</Typography>
                        <Typography>
                          Occupation: {gE ? gE?.occupation : "-"}
                        </Typography>
                      </Stack>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            );
          })}
        </Stack>
      </Box>

      <Box
        sx={{
          marginTop: "20px",
          width: "100%",
          margin: "auto",
          color: "#696984",
        }}
      >
        <Typography
          sx={{
            display: "inline-block",
            marginTop: "15px",
            marginBottom: "15px",
            fontSize: "1.125em",
            color: "#696984",
            fontWeight: "bold",
          }}
        >
          Address:{" "}
          {details?.address?.length == 0 ? (
            <Typography>Adress not available.</Typography>
          ) : null}
        </Typography>

        {details?.address?.length == 0
          ? null
          : details?.address?.map((addEle) => {
              return (
                <Card
                  sx={{
                    backgroundColor: "#FFFFFF",
                    color: "#696984",
                    border: "1px solid #7E7E7E",
                    marginTop: "15px",
                  }}
                >
                  <CardContent>
                    <EditIcon
                      sx={{
                        fontSize: "15px",
                        display: "inline-block",
                        cursor: "pointer",
                        marginLeft: "98%",
                        fontSize: "15px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleClickOpen("addressDetails", addEle)}
                    />

                    <Stack direction="row" spacing={4}>
                      <Box sx={{ width: "190px" }}>
                        <Stack direction="column" spacing={1}>
                          <Typography>
                            Landmark:
                            {addEle ? addEle.landmark : "-"}
                          </Typography>
                          <Typography>
                            City:
                            {addEle ? addEle.city : "-"}
                          </Typography>
                        </Stack>
                      </Box>
                      <Box sx={{ width: "190px" }}>
                        <Stack direction="column" spacing={1}>
                          <Typography>
                            Pincode:
                            {addEle ? addEle.zipcode : "-"}
                          </Typography>
                          <Typography>
                            State:
                            {addEle ? addEle.state : "-"}
                          </Typography>
                        </Stack>
                      </Box>
                    </Stack>
                  </CardContent>
                </Card>
              );
            })}
      </Box>

      <Box
        sx={{
          width: "100%",
          margin: "auto",
          color: "#696984",
        }}
      >
        <Typography
          sx={{
            marginTop: "15px",
            marginBottom: "15px",
            fontSize: "1.125em",
            color: "#696984",
            fontWeight: "bold",
          }}
        >
          Tests Results: {testDet.length === 0 && "No test details available"}
        </Typography>

        <Card
          sx={{
            backgroundColor: "#FFFFFF",
            color: "#696984",
            border: "1px solid #7E7E7E",
            paddingTop: "5px",
            width: "auto",
          }}
          className={testDet.length === 0 && styles.displayCardNone}
        >
          {testDet.map((testData, index) => {
            console.log("666", testDet);

            return (
              <CardContent
                color="#696984"
                sx={{ paddingTop: "0px", paddingBottom: "0px" }}
              >
                <Box>
                  <Typography
                    className={styles.capLetter}
                    onClick={(e) =>
                      openTestPdf(e, details?.id, testData.TestType)
                    }
                  >
                    {testData.TestType === "achievement" ? (
                      <p className={styles.textHover}>Academics:</p>
                    ) : (
                      <p className={styles.textHover}>{testData.TestType}:</p>
                    )}

                    <div className={styles.testBoxGroup}>
                      {testData.data.length == 0 ? (
                        "No details available"
                      ) : (
                        <>
                          <Button size="small" variant="contained">
                            View Report
                          </Button>
                        </>
                      )}
                    </div>
                  </Typography>
                </Box>
              </CardContent>
            );
          })}
        </Card>
      </Box>
      <Box
        sx={{
          width: "100%",
          margin: "auto",
          color: "#696984",
        }}
      >
        <Typography
          sx={{
            marginTop: "15px",
            marginBottom: "15px",
            fontSize: "1.125em",
            color: "#696984",
            fontWeight: "bold",
          }}
        >
          Sessions [{details?.sessions?.length}]
        </Typography>
      </Box>

      <div>
        {details?.sessions?.map((item, index) => {
          const isExpanded = expandedAccordion === index;
          return (
            <Accordion
              expanded={isExpanded}
              onChange={() => setExpandedAccordion(isExpanded ? false : index)}
              key={index}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className={styles.showsessiondetails}>
                  <div className={styles.sessionId}>
                    Session Id : {item?.id}
                  </div>
                  <div className={styles.sessionId}>
                    Session Name: {item?.session_name}
                  </div>
                  <div className={styles.sessionId}>
                    Counsellor: {item?.counsellor ? item?.counsellor : "-"}
                  </div>
                  <div className={styles.sessionId}>
                    Date: {item?.date ? item?.date : "-"}
                  </div>
                  <div className={styles.sessionId}>
                    Time:{" "}
                    {item?.time_slot?.commence
                      ? item?.time_slot?.commence
                      : "-"}
                  </div>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                {categories.map((cat) => (
                  <DynamicCategorySection
                    key={cat.id}
                    category={cat}
                    questions={categoryQuestions[cat.id] || []}
                    sessionId={item.id}
                    answers={categoryAnswers[cat.id]?.[item.id] || []}
                    onAnswerChange={(sessionId, questionId, choice, answer) =>
                      handleCategoryAnswerChange(
                        cat.id,
                        sessionId,
                        questionId,
                        choice,
                        answer
                      )
                    }
                    onSave={(sessionId) =>
                      saveCategoryAnswers(cat.id, sessionId)
                    }
                    CustomComponent={
                      customComponentMap[cat.title] ||
                      customComponentMap["default"]
                    }
                    customComponentProps={{
                      category: cat,
                      sessionId: item.id,
                      userId: details.id,
                      stuProfile:
                        cat.title === "Student Profile"
                          ? testResponce
                          : cat.title === "Judgement"
                          ? judgResponce
                          : cat.title === "Recommendation"
                          ? recoResponce
                          : undefined,
                      area_concern:
                        cat.title === "Area of concern"
                          ? areaResponce
                          : undefined,
                      dream_career:
                        cat.title === "Dream Career Details"
                          ? dreamResponce
                          : undefined,
                    }}
                  />
                ))}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>

      <div>
        <Button
          variant="contained"
          size="small"
          sx={{ minWidth: "115px", margin:"20px 0" }}
          style={{
            backgroundColor: "#32c6b",
          }}
           onClick={() =>
                            handleCareerCounsellingReport(
                              sid,
                              details?.student_test_type
                            )
                          }
        >
          Genrate and downloade Report
        </Button>
      </div>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <EditFieldsForm
          handleClose={handleClose}
          editSection={sectionType}
          editFormDetails={editObject}
          objForForm={objForForm}
        />
      </BootstrapDialog>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default StudentProfile;
export const gender = [
  {
    id: 2,
    name: "Female",
  },
  {
    id: 1,
    name: "Male",
  },
];

export const editSection = [
  {
    type: "userDetails",
    id: 1,
    key: "user",
  },
  {
    type: "guardianDetails",
    id: 2,
    key: "guardian",
  },
  {
    type: "addressDetails",
    id: 3,
    key: "address",
  },
  {
    type: "sessionDetails",
    id: 4,
    key: "sessions",
  },

  {
    type: "sessionNotes",
    id: 5,
    key: "notes",
  },

  {
    type: "bookSlot",
    id: 6,
    key: "bookSlot",
  },
];
